import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import associateServices from "../../../services";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import SkeletonCard from "./skeleton";
import {SkeletonTheme} from "react-loading-skeleton";
import stringHelper from "../../../helpers/string-helper";
import {useTranslation} from "react-i18next";
import store from "../../../reducers/createReducers";
import DataActions from "../../../actions/data-actions";

const MiniSlider = (props) => {
    const {miniSlidersR} = useSelector(state => state.dataReducer)
    const {page, rowItem = 3} = props
    const navigate = useNavigate()
    const {activeLanguage, agent} = useSelector(state => state.globalReducer)
    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const [loading, setLoading] = useState(false)
    const [miniSliders, setMiniSliders] = useState([])

    useEffect(() => {
        if (!loading && !miniSlidersR[`${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}|${page}`]) {
            setLoading(true)
            associateServices.getMiniSliders({
                language: activeLanguage?.key,
                device: agent?.isMobile ? 'mobile' : 'web',
                page
            }).then(res => {
                store.dispatch(DataActions.setMiniSliders({
                    data: res?.data || [],
                    type: `${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}|${page}`
                }))
                setLoading(false)
            })

        }
    }, [activeLanguage?.key, agent?.isMobile, miniSlidersR, loading, page])

    useEffect(() => {
        setMiniSliders(miniSlidersR[`${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}|${page}`] || [])
    }, [miniSlidersR])

    const handleNavigation = slider => {
        if (!slider?.path)
            return false

        if (slider?.path?.startsWith('www') || slider?.path?.startsWith('http'))
            return window.open(slider?.path, '_blank')


        navigate(stringHelper.getLocalizedPath(currentLanguage, slider?.path))
    }


    if (!loading && miniSliders?.length <= 0)
        return null;

    return (
        <div className="section mini-slider pt-24" id="mini-slider-wrapper">
            <div className="container d-flex pt-0">
                <SkeletonTheme baseColor="var(--tf-bg)" highlightColor="var(--tf-bg2)">
                    <Swiper
                        modules={[Navigation]}
                        navigation
                        spaceBetween={12} // Adjust spacing between slides
                        loop={miniSliders?.length >= 4}
                        lazy={"true"}
                        breakpoints={{
                            0: { // Mobile
                                slidesPerView: 1,
                            },
                            640: { // Tablet
                                slidesPerView: 2,
                            },
                            1200: { // Desktop
                                slidesPerView: 3,
                            },
                        }}
                        slidesPerView={1} // Default to 1 slide on smaller screens
                    >
                        {
                            loading ?
                                Array.from({length: 3}).map((_, index) => <SkeletonCard key={index}/>)
                                :
                                miniSliders?.map(slider => (
                                    <SwiperSlide key={slider?.id} onClick={e => handleNavigation(slider)}
                                                 className="mini-swiper">
                                        <div className="slide-content mid-me cursor-pointer">
                                            <img
                                                loading={'lazy'}
                                                src={slider?.image}
                                                alt=""
                                                className="responsive-image"
                                            />
                                            <div className="swiper-lazy-preloader"></div>

                                        </div>
                                    </SwiperSlide>
                                ))

                        }
                    </Swiper>
                </SkeletonTheme>
            </div>
        </div>
    );
};

export default MiniSlider;
